<!-- 1. 수신자 입력 -->
<template>
  <v-row no-gutters>

    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
          <div class="write_s1_alertCon">
      <!--사용자 설정이 개인 일때-->
            <v-tooltip bottom v-if="!getOrgname()">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="alert_wite_info01">
                  <!--v-chip 기업일때만 class="st_cpn"-->
                  <v-chip>개인</v-chip>
                  <span class="txt_name">{{ getName() }}</span>
                  <span class="fc_b03"> 으로</span>
                  <span>계약을 작성합니다.</span>
                </div>
              </template>
              <div>기업담당자로서 계약이 필요한 경우 오른쪽 상단바에서<span class="top_bar_user_icon"></span>를 눌러 변경해주세요</div>
            </v-tooltip>
      <!--/사용자 설정이 개인 일때-->
      <!--사용자 설정이 기업 일때 -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="alert_wite_info01">
                  <v-chip class="st_cpn">기업</v-chip>
                  <span class="txt_cpn"> {{ getOrgname() }} </span>
                  <span class="txt_name">{{ getName() }}</span>
                  <span class="fc_b03"> 으로</span>
                  <span>회사를 대행하여 계약을 작성합니다.</span>
                </div>
              </template>
              <div>개인 계약의 경우 오른쪽 상단바에서<span class="top_bar_user_icon"></span>를 눌러 변경해주세요</div>
            </v-tooltip>
      <!--/사용자 설정이 기업 일때-->
          </div>
          <v-row no-gutters class="row_mb-40">
            <div class="dot_tt">수신자 인증 선택</div>
            <!--5개 중 단일선택-->
            <v-col cols="12">
              <!--간편인증 수신자-->
              <div class="round8_pd20_box box_st_n_cert">
                <div class="roundCbox_ttCon">
                  <span class="roundCbox_tt st_0_44">간편인증</span>
                  <span class="pl-2 pr-2 txt_bg_w">이면 충분해요</span>
                </div>
                <v-radio-group v-model="ctrRadio" class="radioCon" row>
                  <v-radio
                    label="휴대폰 인증"
										:key=KeyNames.ctrLockType.Phone
                    :value=KeyNames.ctrLockType.Phone
										:disabled="(step1Cntrl.disBrkSelBtn === 'Y') ? true : false"
                    v-on:click="ctrLockTypeSelect(KeyNames.ctrLockType.Phone)"
                  ></v-radio>
                  <v-radio
                    label="인증키 입력"
										:key=KeyNames.ctrLockType.Key
                    :value=KeyNames.ctrLockType.Key
										name="ctrKind"
										:disabled="(step1Cntrl.disBrkSelBtn === 'Y') ? true : false"
										v-on:click="ctrLockTypeSelect(KeyNames.ctrLockType.Key)"
                  ></v-radio>
                  <v-radio
                    label="이메일 인증 (무인증)"
										:key=KeyNames.ctrLockType.Email
                    :value=KeyNames.ctrLockType.Email
                      name="ctrKind"
                      :disabled="(step1Cntrl.disBrkSelBtn === 'Y') ? true : false"
                      v-on:click="ctrLockTypeSelect(KeyNames.ctrLockType.Email)"
                  ></v-radio>
                </v-radio-group>
              </div>
            <!--/간편인증 수신자-->
            <!--기업 수신자-->
              <div class="round8_pd20_box box_st_n_cert">
                <div class="roundCbox_ttCon">
                  <span class="roundCbox_tt st_0_0">기업인증</span>
                  <span class="pl-2 pr-2 txt_bg_w">이 필요합니다</span>
                </div>
                <v-radio-group v-model="ctrRadio" class="radioCon" row>
                  <v-radio
                    label="기업용 인증서 인증"
										:key=KeyNames.ctrLockType.Office
                    :value=KeyNames.ctrLockType.Office
										:disabled="(step1Cntrl.disBrkSelBtn === 'Y') ? true : false"
										v-on:click="ctrLockTypeSelect(KeyNames.ctrLockType.Office)"
                  ></v-radio>
                  <!--<v-radio
                    label="사업자번호 인증"
                    value="radio-2"
                  ></v-radio>-->
                </v-radio-group>
              </div>
            <!--/기업 수신자-->

            </v-col>
          </v-row>
          <v-row no-gutters class="row_mb-40">
            <div class="dot_tt">계약 서명 선택</div>
            <div class="txtst_info_gray">공동인증서 서명 선택 시 서명을 위해 요청자, 수신자 모두 공동인증서가 필요합니다.</div>
            <v-col cols="12">
              <v-radio-group class="radioCon" row v-model="signCert">
                <v-radio
                  label="공동인증서 서명"
									:value=1
                  :disabled="(ctrSignRadio1 === true)? false : true"  @change="contractSignSelect(KeyNames.ctrSignType.authSign)"
                ></v-radio>
                <v-radio
                  label="간편 서명"
									:value=0
                  :disabled="(ctrSignRadio2 === true)? false : true"  @change="contractSignSelect(KeyNames.ctrSignType.simpleSign)"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!--수신자 인증-->
          <!--기업인증 수신자/간편인증 수신자 두타입중 하나 선택하여 노출-->
          <v-row no-gutters class="row_mb-40"  v-if="this.companyForm === true">
            <!--기업인증 수신자-->
            <div class="dot_tt">기업 수신자 입력
              <!--<v-checkbox class="ml-2 coNlist_chk" label="다자계약"></v-checkbox>-->
              <!--<v-btn class="btn18_00 search" outlined @click="poPreceiv = true"><span class="icon"></span>검색</v-btn>-->
            </div>
            <v-row no-gutters class="coNlistCon" v-for="(ctrRow, index) of ctrFrmBaseData.ctrFrm" :key="index">
              <!--(반복)-->
              <v-col cols="12" class="coNlist_receiverCpn">
                <!--리스트 숫자-->
                <span class="coNlist_num">{{index}}</span>

                <v-card class="carD_receiverCpn">
									<v-form ref="companyInfo" v-model="valid" lazy-validation>
                  <ul class="pattern_ulTxtBox">
                    <li v-if="ctrRow.isSaved === ''">
                      <!--텍스트 필드 미입력시 에러메세지 노출:00을 입력해주세요(이하 같음)-->
                      <!--필수항목 class에 conBstar 붙여주세요> 라벨에 *표시되는 필드-->
                      <v-text-field class="inputH48_03"
                        label="회사명"
												v-model="ctrRow.receiverName"
												value= ctrRow.receiverName
												:prop="'ctrFrm.' + index + '.receiverName'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <!--텍스트 필드 미입력시 에러메세지 노출:00을 입력해주세요(이하 같음)-->
                      <!--필수항목 class에 conBstar 붙여주세요> 라벨에 *표시되는 필드-->
                      <v-text-field class="inputH48_03"
                        label="회사명" readonly
												v-model="ctrRow.receiverName"
												value= ctrRow.receiverName
												:prop="'ctrFrm.' + index + '.receiverName'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03 conBstar"
                        label="사업자번호"
												maxlength="10" v-model="ctrRow.receiverOrgNum"
												:rules="rules.orgRegnoRequireRules"
												value= ctrRow.receiverOrgNum
												required
												:prop="'ctrFrm.' + index + '.receiverOrgNum'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03 conBstar"
                        label="사업자번호" readonly
												maxlength="10" v-model="ctrRow.receiverOrgNum"
												value= ctrRow.receiverOrgNum
												:prop="'ctrFrm.' + index + '.receiverOrgNum'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03 conBstar"
												v-model="ctrRow.receiverEmail"
                        label="이메일" :rules="rules.emailRules"
												value= ctrRow.receiverEmail
												required
												:prop="'ctrFrm.' + index + '.receiverEmail'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03 conBstar"
												v-model="ctrRow.receiverEmail" readonly
                        label="이메일"
												value= ctrRow.receiverEmail
												:prop="'ctrFrm.' + index + '.receiverEmail'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03"
                        label="이름" :rules="rules.nameRules"
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03"
                        label="이름" readonly
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03"
												v-model="ctrRow.receiverPhone"
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03"
												v-model="ctrRow.receiverPhone" readonly
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
                  </ul>
                  <div class="btnCon_carD_receiv" v-if="ctrRow.isSaved === ''">
                    <v-btn class="btn18_00" outlined @click="ctrTblRowData()">저장</v-btn>
                  </div>
									<div class="btnCon_carD_receiv" v-else>
                    <!--리스트 1개일때는 삭제 X: 최초 삭제 버튼만 disabled(안눌리게) 처리-->
                    <v-btn icon disabled class="btnO_C04 delete" v-if="index === 0"><span class="icon">삭제</span></v-btn>
										<v-btn icon class="btnO_C04 delete" @click="delCtrTblRow(index, ctrFrmBaseData.ctrFrm)" v-else><span class="icon">삭제</span></v-btn>
                  </div>
									</v-form>
                </v-card>
              </v-col>
              <!--/(반복)-->
            </v-row>
						<v-col cols="12">
              <!--반복 리스트 생성:최대 10개(최초 1개 포함)-->
              <!--<v-btn text class="btn17_C01" @click="addReciverData()"><span class="icon"></span>수신자 추가</v-btn>-->
              <!--그룹추가는 신기능으로 1차 반연에 미포함-->
              <!--<v-btn text class="btn17_C01" @click="poPgroup = true"><span class="icon"></span>그룹으로 추가</v-btn>-->
            </v-col>
          </v-row>
					<v-row no-gutters class="row_mb-40"  v-if="this.personForm === true ">
            <div class="dot_tt">수신자 입력</div>
            <v-row no-gutters class="coNlistCon" v-for="(ctrRow, index) of ctrFrmBaseData.ctrFrm1" :key="index">
              <!--(반복)-->
              <v-col cols="12" class="coNlist_receiverCpn">
                <!--리스트 숫자-->
                <span class="coNlist_num">{{index}}</span>
                <!-- 간편:class="carD_receiverCpn st_person" /  기업:class="carD_receiverCpn st_person"-->
                <v-card class="carD_receiverCpn st_person" >
                  <!--  기업:li 4개 버튼 2개 / 간편: li 3개 버튼 1개 -->
									<v-form ref="personInfo">
                  <ul class="pattern_ulTxtBox">
										<li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03 conBstar"
												v-model="ctrRow.receiverEmail"
                        label="이메일" :rules="rules.emailRequireRules"
												value= ctrRow.receiverEmail
												required
												:prop="'ctrFrm.' + index + '.receiverEmail'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03 conBstar"
												v-model="ctrRow.receiverEmail" readonly
                        label="이메일"
												value= ctrRow.receiverEmail
												:prop="'ctrFrm.' + index + '.receiverEmail'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved === '' && ctrRow.lockType === 'PHONE'">
                      <v-text-field class="inputH48_03 conBstar"
                        label="이름" :rules="rules.nameRequireRules"
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved !== '' && ctrRow.lockType === 'PHONE'">
                      <v-text-field class="inputH48_03"
                        label="이름" readonly
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === '' && ctrRow.lockType === 'PHONE'">
                      <v-text-field class="inputH48_03 conBstar"
												v-model="ctrRow.receiverPhone" :rules="rules.phoneRequireRules"
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved !== '' && ctrRow.lockType === 'PHONE'">
                      <v-text-field class="inputH48_03"
												v-model="ctrRow.receiverPhone" readonly
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved === ''  && ctrRow.lockType === 'KEY'">
                      <v-text-field class="inputH48_03 conBstar"
                        label="인증키"
												maxlength="6" v-model="ctrRow.receiverKey"
												:rules="rules.pinRequireRules"
												value= ctrRow.receiverKey
												:prop="'ctrFrm.' + index + '.receiverKey'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved !== '' && ctrRow.lockType === 'KEY'">
                      <v-text-field class="inputH48_03 conBstar"
                        label="인증키" readonly
												maxlength="6" v-model="ctrRow.receiverKey"
												value= ctrRow.receiverKey
												:prop="'ctrFrm.' + index + '.receiverKey'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === ''">
                      <!--텍스트 필드 미입력시 에러메세지 노출:00을 입력해주세요(이하 같음)-->
                      <!--필수항목 class에 conBstar 붙여주세요> 라벨에 *표시되는 필드-->
                      <v-text-field class="inputH48_03"
                        label="회사명"
												v-model="ctrRow.receiverName"
												value= ctrRow.receiverName
												:prop="'ctrFrm.' + index + '.receiverName'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <!--텍스트 필드 미입력시 에러메세지 노출:00을 입력해주세요(이하 같음)-->
                      <!--필수항목 class에 conBstar 붙여주세요> 라벨에 *표시되는 필드-->
                      <v-text-field class="inputH48_03"
                        label="회사명" readonly
												v-model="ctrRow.receiverName"
												value= ctrRow.receiverName
												:prop="'ctrFrm.' + index + '.receiverName'"
                      >
                      </v-text-field>
                    </li>

                    <li v-if="ctrRow.isSaved === ''">
                      <v-text-field class="inputH48_03"
                        label="사업자번호"
												maxlength="10" v-model="ctrRow.receiverOrgNum"
												:rules="rules.orgRegnoRules"
												value= ctrRow.receiverOrgNum
												required
												:prop="'ctrFrm.' + index + '.receiverOrgNum'"
                      >
                      </v-text-field>
                    </li>
										<li v-else>
                      <v-text-field class="inputH48_03"
                        label="사업자번호" readonly
												maxlength="10" v-model="ctrRow.receiverOrgNum"
												value= ctrRow.receiverOrgNum
												:prop="'ctrFrm.' + index + '.receiverOrgNum'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === ''  && ctrRow.lockType !== 'PHONE'">
                      <v-text-field class="inputH48_03"
                        label="이름" :rules="rules.nameRules"
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved !== '' && ctrRow.lockType !== 'PHONE'">
                      <v-text-field class="inputH48_03"
                        label="이름" readonly
												 v-model="ctrRow.receiverBrokerName"
												value= ctrRow.receiverBrokerName
												:prop="'ctrFrm.' + index + '.receiverBrokerName'"
                      >
                      </v-text-field>
                    </li>
                    <li v-if="ctrRow.isSaved === '' && ctrRow.lockType !== 'PHONE'">
                      <v-text-field class="inputH48_03"
												v-model="ctrRow.receiverPhone"
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
										<li v-if="ctrRow.isSaved !== '' && ctrRow.lockType !== 'PHONE'">
                      <v-text-field class="inputH48_03"
												v-model="ctrRow.receiverPhone" readonly
                        label="휴대전화"
												value= ctrRow.receiverPhone
												:prop="'ctrFrm.' + index + '.receiverPhone'"
                      >
                      </v-text-field>
                    </li>
                  </ul>
                  <div class="btnCon_carD_receiv" v-if="ctrRow.isSaved === ''">
										<v-btn class="btn18_00" outlined @click="findReceiverAddress()">저장</v-btn>
                  </div>
									<div class="btnCon_carD_receiv" v-else>
                    <!--리스트 1개일때는 삭제 X: 최초 삭제 버튼만 disabled(안눌리게) 처리
                    :현재 처리 안된상태-->
                    <v-btn icon disabled class="btnO_C04 delete" v-if="index === 0"><span class="icon">삭제</span></v-btn>
										<v-btn icon class="btnO_C04 delete" @click="delCtrTblRow(index, ctrFrmBaseData.ctrFrm1)" v-else><span class="icon">삭제</span></v-btn>
                  </div>
									</v-form>
                </v-card>
              </v-col>
              <!--/(반복)-->
            </v-row>
            <v-col cols="12">
              <!--반복 리스트 생성:최대 10개(최초 1개 포함)-->
              <!--<v-btn text class="btn17_C01" @click="addReciverData()" ><span class="icon"></span>수신자 추가</v-btn>-->
              <!--그룹추가는 신기능으로 1차 반연에 미포함-->
              <!--<v-btn text class="btn17_C01" @click="poPgroup = true"><span class="icon"></span>그룹으로 추가</v-btn>-->
            </v-col>
          </v-row>
        <!--/수신자 인증-->
    </v-col>

		<v-footer bottom class="steperF_btnCon justify-center">
        <v-btn class="btn19_C01" :disabled="ctrWriteBtn" @click="makeReqParamByStep(KeyNames.frmName.ctrFrmStep1)">다음<span class="iconarr stN"></span></v-btn>
    </v-footer>
		<s-confirm ref="confirm"></s-confirm>
  	<s-loading ref="loading"></s-loading>

</v-row>
</template>
<script>

import { orgNumSearchList } from '@/api/join'
import { getUserEmailInfo } from '@/api/user'
import {
	getUserTokenData,
	regNumTxt,
	defaultConstValue,
	makeNewCtrParamsByStep,
	makeGlobalReqParam } from '@/api/contract/addNew'

const KEY_NAMES_OBJ = defaultConstValue()

export default {
  name: 'write',
  components: {
  },
  filters: {
  },
  props:{
		parentData: {}
	},
	mounted() {
		this.reqParamJson = this.parentData
		if (this.reqParamJson[this.KeyNames.ctrTblListName] !== undefined ) {
			this.ctrTblList = this.reqParamJson[this.KeyNames.ctrTblListName]
			this.ctrGlobalFrm = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm]
			this.ctrFrmBaseData.ctrFrm = this.reqParamJson[this.KeyNames.frmName.ctrFrmBaseData]
			this.ctrFrmBaseData.ctrFrm1 = this.reqParamJson[this.KeyNames.frmName.ctrFrmBaseData1]
			this.$nextTick(() => {
				this.requestDisplay()
			})
    }else {
			this.$nextTick(() => {
				this.doStartPgmPrc()
			})
		}
	},
  data () {
    return {
			rules: {
				nameRules: [
					v => /^[가-힇]*$/.test(v) || '한글만 입력해주세요.'
				],
				nameRequireRules: [
					v => !!v || '이름을 입력해주세요.',
					v => /^[가-힇]*$/.test(v) || '한글만 입력해주세요.'
				],
				orgRegnoRules:[
					v => /^[0-9]*$/.test(v) || '숫자만 입력해주세요.'
				],
				pinRequireRules:[
					v => (v && v.length === 6) || '인증키는 6자리입니다.',
					v => /^[0-9]*$/.test(v) || '숫자만 입력해주세요.'
				],
				orgRegnoRequireRules:[
					v => !!v || '사업자번호를 입력해주세요.',
					v => (v && v.length === 10) || '사업자등록번호는 10자리입니다.',
					v => /^[0-9]*$/.test(v) || '숫자만 입력해주세요.'
				],
				emailRules: [
					v => /.+@.+\..+/.test(v) || '이메일 형식을 확인 해주세요.',
				],
				emailRequireRules: [
					v => !!v || '이메일을 입력해 주세요.',
					v => /.+@.+\..+/.test(v) || '이메일 형식을 확인 해주세요.',
				],
				phoneRules: [
					v => (/^(01[016789]{1})([0-9]{7,8})$/.test(v) && v.length !==0 ) || '핸드폰 형식을 확인해 주세요'
				],
				phoneRequireRules: [
					v => !!v || '핸드폰 번호를 입력해주세요.',
					v => (/^(01[016789]{1})([0-9]{7,8})$/.test(v) && v.length !==0 ) || '핸드폰 형식을 확인해 주세요'
				],
			},
			valid: true,
			signCert: '',
			ctrWriteBtn: '',
			KeyNames: KEY_NAMES_OBJ,
			ctrSignRadio1: false,
			ctrSignRadio2: false,
			companyForm: false,
			personForm: false,
			reqParamJson: {},
			step1Cntrl: {
        disBrkSelBtn: 'N',
				disPsnlSelBtn: 'N',
				lockBtnValue: '',
				singBtnValue: '',
        ctrTbl: false,
        ctrNewBtn: false,
        addRowBtn: true,
        ctrRcvInfoManualBtn: false,
        isInitSetCtrTbl: true,
        isManualInputReceiverInfo: false,
        isFinalCtrTableData: false,
        disableReceiverBrokerChkYN: 'N',
        receiverInfoQueryListLoading: false,
        receiverBrokerInfoQueryListLoading: false,
        disableCtrTblSort: false
			},
			personalBrokerPrcFlag: '', // PERSONAL : 개인계약, BROKER : 계약대행
			rcvSrchKindPrcFlag: '', // PSNL_RECEIVER : 개인수신자, ORG_RECEIVER : 조직수신자
			orgPaymentInfo: '',
			ctrRadio: '',
			ctrTblList: [],
			ctrFormBaseType: '',
			ctrLockTypeForFrm: '',
			ctrFrmBaseData: {
				ctrFrm: [],
				ctrFrm1: []
      },
			simpleFormVisible: false,
			companyFormVisible: false,
			ctrGlobalFrm: {
        ctrNo: '',
        ownerAddress: '',
        ownerName: '',
        senderAddress: '',
        senderName: '',
        senderBrokerAddress: '',
        senderBrokerName: '',
        receiverAddress: '',
        receiverName: '',
        receiverBrokerAddress: '',
        receiverBrokerName: '',
        receiverBrokerChkYN: false,
        receiverEmail: '',
        receiverPhone: '',
        receiverOrgNum: '',
        receiverKey: '',
        ctrLockType: '',
        ctrSignType: '',
        ctrEmailMessage: ''
      },
			companyInfo: {
        receiverName: '',
				receiverOrgNum: '',
				receiverEmail: '',
				receiverBrokerName: '',
				receiverPhone: ''
			},
			personInfo: {
        receiverName: '',
				receiverOrgNum: '',
				receiverEmail: '',
				receiverBrokerName: '',
				receiverPhone: '',
				receiverKey: ''
			},
			step: 1,
			ctrFrmStep1: {
        ctrKind: '',
        rcvSrchKind: ''
      },
      // 스텝퍼
      e1: 1,
      // 다이얼로그
      poPprove00: false,
      poPreceiv: false,
      poPgroup: false,
      plusGroup: false,
      next2step: false,
      paying: false,
      payEnd: false,
      saveYn: false,
      ReceiverAddress: ''
    }
  },
  created () {
  },
  methods: {
		doStartPgmPrc() {
      getUserTokenData(this.reqParamJson).then(response => {
        if (response.rcode === 20000) {
          var tmpUserToken = response.rdata.userInfo
          var orgChainAddr = tmpUserToken.orgChainAddr
          this.paymentChainAddr = tmpUserToken.userChainAddr
          this.ctrGlobalFrm.ctrNo = response.rdata.ctrNo

          this.userToken = response.rdata.userInfo
          // 전역 파라미터 데이터에도 token 데이터를 셋팅해준다
          this.reqParamJson[this.KeyNames.reqParamKeys.userToken] = this.userToken

          // OrgPoint 관련 currPoint
          if (response.rdata.orgPoint.code === 1) {
            this.orgPaymentInfo = response.rdata.orgPoint.currPoint
          } else {
            this.orgPaymentInfo = 0
					}

					var ctrTypeFlag = ''
					if (this.getOrgname()) {
						ctrTypeFlag = this.KeyNames.ctrKind.broker
					}else {
						ctrTypeFlag = this.KeyNames.ctrKind.personal
					}

					// 개인, 계약대행 계약 선택여부 상태 설정
					this.personalBrokerPrcFlag = ctrTypeFlag

					// 계약유형 상태 설정
					this.ctrFrmStep1.ctrKind = ctrTypeFlag

					if (this.personalBrokerPrcFlag === this.KeyNames.ctrKind.broker) {
						// 기업계약일때 수신자 선택창에서 조직수신자 선택되도록 함
						this.ctrFrmStep1.rcvSrchKind = this.KeyNames.rcvSrchKind.broker
					} else if (this.personalBrokerPrcFlag === this.KeyNames.ctrKind.personal) {
						// 개인계약일때 수신자 선택창에서 개인수신자 선택되도록 함
						this.ctrFrmStep1.rcvSrchKind = this.KeyNames.rcvSrchKind.personal
					}

					var ctrTblListBaseData = {}
					var viewSenderName = ''
					var viewSenderBrokerName = ''
					// 처음 생성되는 테이블 row이기 때문에 데이터 받아온 후 isFirstRecord를
          if (ctrTypeFlag === this.KeyNames.ctrKind.personal) { // 개인계약
            viewSenderName = (
              this.userToken.userEmail !== undefined &&
              this.userToken.userEmail !== ''
            ) ? ' (' + this.userToken.userEmail + ')' : ''
            ctrTblListBaseData = {
              ctrOrder: 1,
              ownerAddress: this.userToken.userChainAddr,
              ownerName: this.userToken.userName + viewSenderName,
              senderAddress: this.userToken.userChainAddr,
              senderName: this.userToken.userName + viewSenderName,
              senderBrokerAddress: '',
              senderBrokerName: '',
              senderOrganizationRegistrationNumber: '',
              receiverAddress: '',
              receiverName: '',
              receiverBrokerAddress: '',
              receiverBrokerName: '',
              receiverOrganizationRegistrationNumber: '',
              isFirstRecord: true,
              receiverEmail: '',
              receiverPhone: '',
              receiverKey: '',
              receiverOrgNum: ''
            }
            this.ctrGlobalFrm.ownerAddress = this.userToken.userChainAddr
            this.ctrGlobalFrm.ownerName = this.userToken.userName + viewSenderName
            this.ctrGlobalFrm.senderAddress = this.userToken.userChainAddr
            this.ctrGlobalFrm.senderName = this.userToken.userName + viewSenderName

            this.ctrTblList.push(ctrTblListBaseData)
          } else if (ctrTypeFlag === this.KeyNames.ctrKind.broker) { // 기업(조직)계약
            if (
              (this.userToken.orgChainAddr === undefined || this.userToken.orgChainAddr == null || this.userToken.orgChainAddr === '') &&
              (this.userToken.userChainAddr !== undefined && this.userToken.userChainAddr != null && this.userToken.userChainAddr !== '')
            ) {
              viewSenderName = (
                this.userToken.userEmail !== undefined &&
                this.userToken.userEmail !== ''
              ) ? ' (' + this.userToken.userEmail + ')' : ''
              // 기업소속이 아닌 완전 개인일 경우 셋팅
              ctrTblListBaseData = {
                ctrOrder: 1,
                ownerAddress: this.userToken.userChainAddr,
                ownerName: this.userToken.userName + viewSenderName,
                senderAddress: this.userToken.userChainAddr,
                senderName: this.userToken.userName + viewSenderName,
                senderBrokerAddress: '',
                senderBrokerName: '',
                senderOrganizationRegistrationNumber: '',
                receiverAddress: '',
                receiverName: '',
                receiverBrokerAddress: '',
                receiverBrokerName: '',
                receiverOrganizationRegistrationNumber: '',
                isFirstRecord: true,
                receiverEmail: '',
                receiverPhone: '',
                receiverKey: '',
                receiverOrgNum: ''
              }
              this.ctrGlobalFrm.ownerAddress = this.userToken.userChainAddr
              this.ctrGlobalFrm.ownerName = this.userToken.userName + viewSenderName
              this.ctrGlobalFrm.senderAddress = this.userToken.userChainAddr
              this.ctrGlobalFrm.senderName = this.userToken.userName + viewSenderName
            } else {
              viewSenderBrokerName = (
                this.userToken.userEmail !== undefined &&
                this.userToken.userEmail !== ''
              ) ? ' (' + this.userToken.userEmail + ')' : ''

              let viewSenderNameOrg = ''
              if (
                (this.userToken.organizationRegistrationNumber !== undefined && this.userToken.organizationRegistrationNumber !== '') &&
                (this.userToken.userEmail !== undefined && this.userToken.userEmail !== '')
              ) {
                // 사업자등록번호, 사용자 Email이 Token에 모두 존재할경우 사업자 등록번호 표현을 우선으로 한다(기업표현)
                viewSenderNameOrg = ' (' + regNumTxt(this.userToken.organizationRegistrationNumber) + ')'
              } else if (
                (this.userToken.organizationRegistrationNumber !== undefined && this.userToken.organizationRegistrationNumber !== '') &&
                (this.userToken.userEmail === undefined || this.userToken.userEmail === '')
              ) {
                // 사업자 등록번호는 존재, 사용자 Email은 존재하지 않을 경우 기업표현을 한다
                viewSenderNameOrg = ' (' + regNumTxt(this.userToken.organizationRegistrationNumber) + ')'
              } else if (
                (this.userToken.organizationRegistrationNumber === undefined || this.userToken.organizationRegistrationNumber !== '') &&
                (this.userToken.userEmail !== undefined || this.userToken.userEmail !== '')
              ) {
                // 사업자 등록번호는 존재하지 않고 사용자 Email은 존재할때 - 잘못된 데이터로 예상할 수 있으나
                // 표현은 Email이라도 넣어준다
                viewSenderNameOrg = ' (' + this.userToken.userEmail + ')'
              } else {
                // 사업자 등록번호, Email이 모두 없으면 잘못된 내용으로 간주할 수 있음,
                // 만약 기업등록을 했는데 이런 데이터가 있다면 확인이 필요함
                viewSenderNameOrg = ''
              }
              ctrTblListBaseData = {
                ctrOrder: 1,
                ownerAddress: this.userToken.orgChainAddr,
                ownerName: this.userToken.orgName + viewSenderNameOrg,
                senderAddress: this.userToken.orgChainAddr,
                senderName: this.userToken.orgName + viewSenderNameOrg,
                senderBrokerAddress: this.userToken.userChainAddr,
                senderBrokerName: this.userToken.userName + viewSenderBrokerName,
                senderOrganizationRegistrationNumber: this.userToken.organizationRegistrationNumber,
                receiverAddress: '',
                receiverName: '',
                receiverBrokerAddress: '',
                receiverBrokerName: '',
                receiverOrganizationRegistrationNumber: '',
                isFirstRecord: true,
                receiverEmail: '',
                receiverPhone: '',
                receiverKey: '',
                receiverOrgNum: ''
              }
              this.ctrGlobalFrm.ownerAddress = this.userToken.orgChainAddr
              this.ctrGlobalFrm.ownerName = this.userToken.orgName + viewSenderNameOrg
              this.ctrGlobalFrm.senderAddress = this.userToken.orgChainAddr
              this.ctrGlobalFrm.senderName = this.userToken.orgName + viewSenderNameOrg
              this.ctrGlobalFrm.senderBrokerAddress = this.userToken.userChainAddr
              this.ctrGlobalFrm.senderBrokerName = this.userToken.userName + viewSenderBrokerName
              this.ctrGlobalFrm.organizationRegistrationNumber = this.userToken.organizationRegistrationNumber
            }
            this.ctrTblList.push(ctrTblListBaseData)
          } else {
            this.ctrTblList = []
          }

          if (orgChainAddr === undefined || orgChainAddr === null || orgChainAddr === '') {
            // 자가 개인 사용자일 때 계약유형 기업계약 유형을 disable 시킨다
						// 기업사용자일 경우에는 놔둠

						if (this.KeyNames.ctrKind.broker === ctrTypeFlag) {
							if (this.orgPaymentInfo < 3300) {
								this.$refs.confirm.open('confirm', '포인트 부족', '포인트가 부족합니다. 계약 요청을 위해 포인트를 충전 후에 이용해주세요.').then(() => {
									this.$router.push({ name: 'taxInfo' })
								})
							}
						}
          } else {
          }
        } else {
          // 계약유형 선택 버튼 둘다 비활성화
					this.$refs.confirm.open('alert', '사용자정보', '사용자 정보가 존재하지 않아 진행할 수 없습니다.')
        }
      }).catch(() => {
        this.ctrGlobalFrm.ctrNo = ''
        this.ctrTblList = []
        // 계약유형 선택 버튼 둘다 비활성화
				this.$refs.confirm.open('alert', '사용자정보', '사용자 정보가 존재하지 않아 진행할 수 없습니다.')
			})
    },
		/* 타입을 바꿀시 form 데이터를 리셋함. 기본 데이터를 삽입해줘야함 */
		setCtrList(index) {
			if(index === 1) {
				this.ctrFrmBaseData.ctrFrm = []
				this.ctrFrmBaseData.ctrFrm1 = []
			}
			let ctrTblListBaseData = {}
        ctrTblListBaseData = {
          ctrOrder: index,
          receiverName: '',
          receiverOrgNum: '',
          receiverEmail: '',
          receiverPhone: '',
          receiverKey: '',
					receiverBrokerName: '',
					lockType: this.ctrGlobalFrm.ctrLockType,
					isSaved: ''
				}
				if(this.ctrGlobalFrm.ctrLockType === 'OFFICE') {
					this.ctrFrmBaseData.ctrFrm.push(ctrTblListBaseData)
				}else {
					this.ctrFrmBaseData.ctrFrm1.push(ctrTblListBaseData)
				}

				this.signCert = ''
		},
		getName () {
      this.userName = this.$store.state.user.username
      return this.$store.state.user.username
    },
    getOrgname() {
      return this.$store.state.user.orgname
		},
		ctrTblPersonalListSet (index) {
      // 계약 발송자가 개인인 경우.
      let viewSenderNameOrg = ''
      if (
        (this.userToken.userEmail !== undefined && this.userToken.userEmail !== '')
      ) {
        // 사업자등록번호, 사용자 Email이 Token에 모두 존재할경우 사업자 등록번호 표현을 우선으로 한다(기업표현)
        viewSenderNameOrg = ' (' + this.userToken.userEmail + ')'
      } else if (
        (this.userToken.organizationRegistrationNumber !== undefined && this.userToken.organizationRegistrationNumber !== '') &&
        (this.userToken.userEmail === undefined || this.userToken.userEmail === '')
      ) {
        // 사업자 등록번호는 존재, 사용자 Email은 존재하지 않을 경우 기업표현을 한다
        viewSenderNameOrg = ' (' + regNumTxt(this.userToken.organizationRegistrationNumber) + ')'
      } else if (
        (this.userToken.organizationRegistrationNumber === undefined || this.userToken.organizationRegistrationNumber !== '') &&
        (this.userToken.userEmail !== undefined || this.userToken.userEmail !== '')
      ) {
        // 사업자 등록번호는 존재하지 않고 사용자 Email은 존재할때 - 잘못된 데이터로 예상할 수 있으나
        // 표현은 Email이라도 넣어준다
        viewSenderNameOrg = ' (' + this.userToken.userEmail + ')'
      }
      if (index === 0) {
      } else {
        let ctrTblListBaseData = {}
        ctrTblListBaseData = {
          ctrOrder: index + 1,
          ownerAddress: this.userToken.userChainAddr,
          ownerName: this.userToken.userName + viewSenderNameOrg,
          senderAddress: this.userToken.userChainAddr,
          senderName: this.userToken.userName + viewSenderNameOrg,
          senderBrokerAddress: '',
          senderBrokerName: '',
          senderOrganizationRegistrationNumber: this.userToken.organizationRegistrationNumber,
          receiverAddress: '',
          receiverName: '',
          receiverBrokerAddress: '',
          receiverBrokerName: '',
          receiverOrganizationRegistrationNumber: '',
          receiverEmail: '',
          receiverPhone: '',
          receiverKey: '',
          receiverOrgNum: ''
        }
        this.ctrTblList.push(ctrTblListBaseData)
      }
    },
    findReceiverAddress () {
      this.ReceiverAddress = ''
      if (this.ctrGlobalFrm.ctrLockType === this.KeyNames.ctrLockType.Office) {
        this.ctrFrmBaseData.ctrFrm.forEach((item, index, array) => {
          if (item.receiverOrgNum) {
            orgNumSearchList(JSON.stringify({ regNum: item.receiverOrgNum })).then(Response => {
              if (Response.rdata.rcode === 20000) {
                this.ReceiverAddress = Response.rdata.orginfo.chainAddress
              } else {
                this.ReceiverAddress = ''
              }
            }).then(() => {
              this.ctrTblRowData()
            })
          } else {
            getUserEmailInfo(JSON.stringify({ userEmail: item.receiverEmail })).then(Response => {
              if (Response.rdata.rcode === 20000) {
                this.ReceiverAddress = Response.rdata.user.chainAddress
              } else {
                this.ReceiverAddress = ''
              }
            }).then(() => {
              this.ctrTblRowData()
            })
          }
        })
      } else {
        this.ctrFrmBaseData.ctrFrm1.forEach((item, index, array) => {
          if (item.receiverOrgNum) {
            orgNumSearchList(JSON.stringify({ regNum: item.receiverOrgNum })).then(Response => {
              if (Response.rdata.rcode === 20000) {
                this.ReceiverAddress = Response.rdata.orginfo.chainAddress
              } else {
                this.ReceiverAddress = ''
              }
            }).then(() => {
              this.ctrTblRowData()
            })
          } else {
            getUserEmailInfo(JSON.stringify({ userEmail: item.receiverEmail })).then(Response => {
              if (Response.rdata.rcode === 20000) {
                this.ReceiverAddress = Response.rdata.user.chainAddress
              } else {
                this.ReceiverAddress = ''
              }
            }).then(() => {
              this.ctrTblRowData()
            })
          }
        })
      }
    },
		ctrTblRowData () {
			// 발신자가 개인 계약인 경우
			if (!this.getOrgname()) {
				// 수신자 열람이 기업인증인 경우
				if (this.ctrGlobalFrm.ctrLockType === this.KeyNames.ctrLockType.Office) {
					this.ctrFrmBaseData.ctrFrm.forEach((item, index, array) => {
						if(item.isSaved === '') {
							var validate = this.$refs.companyInfo[index].validate()
							if(validate) {

								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverName', item.receiverName)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverOrgNum', item.receiverOrgNum)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverEmail', item.receiverEmail)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverBrokerName', item.receiverBrokerName)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverPhone', item.receiverPhone)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'isSaved', 'Y')

								this.ctrTblPersonalListSet(index)
								let receiverViewName = ''
								let receiverBrokerViewName = ''

								// 기업 계약의 경우, 이메일과 사업자등록번호가 반드시 존재하게 되어 있음.
								if (item.receiverOrgNum !== '' && item.receiverOrgNum !== null && item.receiverOrgNum !== undefined) {
									if (item.receiverName !== '' && item.receiverName !== null && item.receiverName !== undefined) {
										receiverViewName = item.receiverName + ' (' + regNumTxt(item.receiverOrgNum) + ')'
									} else {
										receiverViewName = regNumTxt(item.receiverOrgNum)
									}
								}

								if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
									receiverBrokerViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
								} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
									receiverBrokerViewName = item.receiverEmail
								}

								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverName, receiverViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverAddress, this.ReceiverAddress)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerName, receiverBrokerViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerAddress, '')
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverKey, item.receiverKey)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverEmail, item.receiverEmail)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverPhone, item.receiverPhone)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverOrgNum, item.receiverOrgNum)
								this.$set(this.ctrTblList[index], 'receiverOrganizationRegistrationNumber', item.receiverOrgNum)
								this.$refs.confirm.open('alert', '수신자 등록', '저장 되었습니다.')
							}else {
								this.$refs.confirm.open('alert', '입력값', '입력 데이터를 확인해주세요.')
							}
						}
					})
					this.ctrGlobalFrm.ownerAddress = this.ctrTblList[0].ownerAddress
					this.ctrGlobalFrm.ownerName = this.ctrTblList[0].ownerName
					this.ctrGlobalFrm.senderAddress = this.ctrTblList[0].senderAddress
					this.ctrGlobalFrm.senderName = this.ctrTblList[0].senderName
					this.ctrGlobalFrm.receiverKey = this.ctrTblList[0].receiverKey
					this.ctrGlobalFrm.receiverEmail = this.ctrTblList[0].receiverEmail
					this.ctrGlobalFrm.receiverPhone = this.ctrTblList[0].receiverPhone
					this.ctrGlobalFrm.receiverOrgNum = this.ctrTblList[0].receiverOrgNum
				} else {
					// 열람 인증 유형이 기업인증이 아닌 경우, 다른 열람 인증을 한 기업 계약이 발생할 수 있으므로
					// 사업자 등록번호의 유무에 따라 판단하도록 함.
					this.ctrFrmBaseData.ctrFrm1.forEach((item, index, array) => {
						if(item.isSaved === '') {
							var validate = this.$refs.personInfo[index].validate()
							if(validate) {
								this.ctrTblPersonalListSet(index)
								let receiverViewName = ''
								let receiverBrokerViewName = ''

								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverName', item.receiverName)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverOrgNum', item.receiverOrgNum)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverEmail', item.receiverEmail)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverBrokerName', item.receiverBrokerName)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverPhone', item.receiverPhone)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverKey', item.receiverKey)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'isSaved', 'Y')

								// 기업 인증이 아닌 경우, 사업자 등록번호가 있을 시 기업계약이므로 receiverName은 기업이 된다.
								// 사업자 등록번호만 입력한 경우
								if (item.receiverOrgNum !== '' && item.receiverOrgNum !== null && item.receiverOrgNum !== undefined) {
									if (item.receiverName !== '' && item.receiverName !== null && item.receiverName !== undefined) {
										receiverViewName = item.receiverName + ' (' + regNumTxt(item.receiverOrgNum) + ')'
									} else if (item.receiverName === '' || item.receiverName === null || item.receiverName === undefined) {
										receiverViewName = regNumTxt(item.receiverOrgNum)
									}

									if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
										receiverBrokerViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
									} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
										receiverBrokerViewName = item.receiverEmail
									}
								}
								// 사업자 등록번호가 없는 경우, 개인계약이므로 receiverBroker가 receiver가 된다
								// 이름이 없는 경우가 있으므로 데이터를 정리하여 준다.
								if (item.receiverOrgNum === '' || item.receiverOrgNum === null || item.receiverOrgNum === null) {
									if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
										receiverViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
										receiverBrokerViewName = ''
									} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
										receiverViewName = item.receiverEmail
										receiverBrokerViewName = ''
									}
								}
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverName, receiverViewName)
								// 비회원일 경우에는 없다.
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverAddress, this.ReceiverAddress)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerName, receiverBrokerViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerAddress, '')
								if(item.receiverKey !== undefined) {
                  this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverKey, item.receiverKey)
                }
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverEmail, item.receiverEmail)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverPhone, item.receiverPhone)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverOrgNum, item.receiverOrgNum)
								this.$set(this.ctrTblList[index], 'receiverOrganizationRegistrationNumber', item.receiverOrgNum)
								this.$refs.confirm.open('alert', '수신자 등록', '저장 되었습니다.')
							}else {
								this.$refs.confirm.open('alert', '입력값', '입력 데이터를 확인해주세요.')
							}
						}
					})
					this.ctrGlobalFrm.ownerAddress = this.ctrTblList[0].ownerAddress
					this.ctrGlobalFrm.ownerName = this.ctrTblList[0].ownerName
					this.ctrGlobalFrm.senderAddress = this.ctrTblList[0].senderAddress
					this.ctrGlobalFrm.senderName = this.ctrTblList[0].senderName
					this.ctrGlobalFrm.receiverKey = this.ctrTblList[0].receiverKey
					this.ctrGlobalFrm.receiverEmail = this.ctrTblList[0].receiverEmail
					this.ctrGlobalFrm.receiverPhone = this.ctrTblList[0].receiverPhone
					this.ctrGlobalFrm.receiverOrgNum = this.ctrTblList[0].receiverOrgNum
				}
			} else { // 기업계약
				// 서명 유형이 기업인증인 경우.
				if (this.ctrGlobalFrm.ctrLockType === this.KeyNames.ctrLockType.Office) {
					this.ctrFrmBaseData.ctrFrm.forEach((item, index, array) => {
						if(item.isSaved === '') {
							var validate = this.$refs.companyInfo[index].validate()
							if(validate) {
								this.ctrTblOrgListSet(index)

								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverName', item.receiverName)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverOrgNum', item.receiverOrgNum)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverEmail', item.receiverEmail)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverBrokerName', item.receiverBrokerName)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'receiverPhone', item.receiverPhone)
								this.$set(this.ctrFrmBaseData.ctrFrm[index], 'isSaved', 'Y')

								let receiverViewName = ''
								let receiverBrokerViewName = ''
								// 기업 계약의 경우, 이메일과 사업자등록번호가 반드시 존재하게 되어 있음.
								if (item.receiverOrgNum !== '' && item.receiverOrgNum !== null && item.receiverOrgNum !== undefined) {
									if (item.receiverName !== '' && item.receiverName !== null && item.receiverName !== undefined) {
										receiverViewName = item.receiverName + ' (' + regNumTxt(item.receiverOrgNum) + ')'
									} else {
										receiverViewName = regNumTxt(item.receiverOrgNum)
									}
								}

								if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
									receiverBrokerViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
								} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
									receiverBrokerViewName = item.receiverEmail
								}
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverName, receiverViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverAddress, this.ReceiverAddress)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerName, receiverBrokerViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerAddress, '')
								if(item.receiverKey !== undefined) {
                  this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverKey, item.receiverKey)
                }
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverEmail, item.receiverEmail)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverPhone, item.receiverPhone)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverOrgNum, item.receiverOrgNum)
								this.$set(this.ctrTblList[index], 'receiverOrganizationRegistrationNumber', item.receiverOrgNum)
								this.$refs.confirm.open('alert', '수신자 등록', '저장 되었습니다.')
							}else {
								this.$refs.confirm.open('alert', '입력값', '입력 데이터를 확인해주세요.')
							}
						}
					})
					this.ctrGlobalFrm.ownerAddress = this.ctrTblList[0].ownerAddress
					this.ctrGlobalFrm.ownerName = this.ctrTblList[0].ownerName
					this.ctrGlobalFrm.senderAddress = this.ctrTblList[0].senderAddress
					this.ctrGlobalFrm.senderName = this.ctrTblList[0].senderName
					this.ctrGlobalFrm.receiverKey = this.ctrTblList[0].receiverKey
					this.ctrGlobalFrm.receiverEmail = this.ctrTblList[0].receiverEmail
					this.ctrGlobalFrm.receiverPhone = this.ctrTblList[0].receiverPhone
					this.ctrGlobalFrm.receiverOrgNum = this.ctrTblList[0].receiverOrgNum
				} else {
					// 열람 인증 유형이 기업인증이 아닌 경우, 다른 열람 인증을 한 기업 계약이 발생할 수 있으므로
					// 사업자 등록번호의 유무에 따라 판단하도록 함.
					this.ctrFrmBaseData.ctrFrm1.forEach((item, index, array) => {
						if(item.isSaved === '') {
							var validate = this.$refs.personInfo[index].validate()
							if(validate) {
								this.ctrTblOrgListSet(index)

								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverName', item.receiverName)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverOrgNum', item.receiverOrgNum)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverEmail', item.receiverEmail)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverBrokerName', item.receiverBrokerName)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverPhone', item.receiverPhone)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'receiverKey', item.receiverKey)
								this.$set(this.ctrFrmBaseData.ctrFrm1[index], 'isSaved', 'Y')

								let receiverViewName = ''
								let receiverBrokerViewName = ''

								// 기업 인증이 아닌 경우, 사업자 등록번호가 있을 시 기업계약이므로 receiverName은 기업이 된다.
								// 사업자 등록번호만 입력한 경우
								if (item.receiverOrgNum !== '' && item.receiverOrgNum !== null && item.receiverOrgNum !== undefined) {
									if (item.receiverName !== '' && item.receiverName !== null && item.receiverName !== undefined) {
										receiverViewName = item.receiverName + ' (' + regNumTxt(item.receiverOrgNum) + ')'
										this.ctrSingRadio1 = 'AUTH'
									} else if (item.receiverName === '' || item.receiverName === null || item.receiverName === undefined) {
										receiverViewName = regNumTxt(item.receiverOrgNum)
										this.ctrSingRadio1 = 'AUTH'
									}

									if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
										receiverBrokerViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
										this.ctrSingRadio1 = 'AUTH'
									} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
										receiverBrokerViewName = item.receiverEmail
										this.ctrSingRadio1 = 'AUTH'
									}
								}
								// 사업자 등록번호가 없는 경우, 개인계약이므로 receiverBroker가 receiver가 된다
								// 이름이 없는 경우가 있으므로 데이터를 정리하여 준다.
								if (item.receiverOrgNum === '' || item.receiverOrgNum === null || item.receiverOrgNum === null) {
									if (item.receiverBrokerName !== '' && item.receiverBrokerName !== null && item.receiverBrokerName !== undefined) {
										receiverViewName = item.receiverBrokerName + ' (' + item.receiverEmail + ')'
										receiverBrokerViewName = ''
										this.ctrSingRadio1 = 'PERSONAL'
									} else if (item.receiverBrokerName === '' || item.receiverBrokerName === null || item.receiverBrokerName === undefined) {
										receiverViewName = item.receiverEmail
										receiverBrokerViewName = ''
										this.ctrSingRadio1 = 'PERSONAL'
									}
								}
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverName, receiverViewName)
								// 비회원일 경우에는 없다.
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverAddress, this.ReceiverAddress)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerName, receiverBrokerViewName)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverBrokerAddress, '')

								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverKey, item.receiverKey)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverEmail, item.receiverEmail)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverPhone, item.receiverPhone)
								this.$set(this.ctrTblList[index], this.KeyNames.ctrTblKeys.receiverOrgNum, item.receiverOrgNum)
								this.$set(this.ctrTblList[index], 'receiverOrganizationRegistrationNumber', item.receiverOrgNum)
								this.$refs.confirm.open('alert', '수신자 등록', '저장 되었습니다.')
							}else {
								this.$refs.confirm.open('alert', '입력값', '입력 데이터를 확인해주세요.')
							}
						}
					})
					this.ctrGlobalFrm.ownerAddress = this.ctrTblList[0].ownerAddress
					this.ctrGlobalFrm.ownerName = this.ctrTblList[0].ownerName
					this.ctrGlobalFrm.senderAddress = this.ctrTblList[0].senderAddress
					this.ctrGlobalFrm.senderName = this.ctrTblList[0].senderName
					this.ctrGlobalFrm.receiverKey = this.ctrTblList[0].receiverKey
					this.ctrGlobalFrm.receiverEmail = this.ctrTblList[0].receiverEmail
					this.ctrGlobalFrm.receiverPhone = this.ctrTblList[0].receiverPhone
					this.ctrGlobalFrm.receiverOrgNum = this.ctrTblList[0].receiverOrgNum
				}
			}
      this.authRadio = ''
      this.saveYn = true
			if(this.ctrGlobalFrm.ctrSignType !== '') {
        this.ctrWriteBtn = false
			}
		},
		ctrTblOrgListSet (index) {
			let viewSenderBrokerName = ''
      viewSenderBrokerName = (
        this.$store.state.user.useremail !== undefined &&
        this.$store.state.user.useremail !== ''
      ) ? ' (' + this.$store.state.user.useremail + ')' : ''

      let viewSenderNameOrg = ''
      if (
        (this.$store.state.user.orgreg !== undefined && this.$store.state.user.orgreg !== '') &&
        (this.$store.state.user.useremail !== undefined && this.$store.state.user.useremail !== '')
      ) {
        // 사업자등록번호, 사용자 Email이 Token에 모두 존재할경우 사업자 등록번호 표현을 우선으로 한다(기업표현)
        viewSenderNameOrg = ' (' + regNumTxt(this.$store.state.user.orgreg) + ')'
      } else if (
        (this.$store.state.user.orgreg !== undefined && this.$store.state.user.orgreg !== '') &&
        (this.$store.state.user.useremail === undefined || this.$store.state.user.useremail === '')
      ) {
        // 사업자 등록번호는 존재, 사용자 Email은 존재하지 않을 경우 기업표현을 한다
        viewSenderNameOrg = ' (' + regNumTxt(this.$store.state.user.orgreg) + ')'
      } else if (
        (this.$store.state.user.orgreg === undefined || this.$store.state.user.orgreg !== '') &&
        (this.$store.state.user.useremail !== undefined || this.$store.state.user.useremail !== '')
      ) {
        // 사업자 등록번호는 존재하지 않고 사용자 Email은 존재할때 - 잘못된 데이터로 예상할 수 있으나
        // 표현은 Email이라도 넣어준다
        viewSenderNameOrg = ' (' + this.$store.state.user.useremail + ')'
      } else {
        // 사업자 등록번호, Email이 모두 없으면 잘못된 내용으로 간주할 수 있음,
        // 만약 기업등록을 했는데 이런 데이터가 있다면 확인이 필요함
        viewSenderNameOrg = ''
      }
      if (index === 0) {
      } else {
        let ctrTblListBaseData = {}
        ctrTblListBaseData = {
          ctrOrder: index + 1,
          ownerAddress: this.$store.state.user.orgaddr,
          ownerName: this.$store.state.user.orgname + viewSenderNameOrg,
          senderAddress: this.$store.state.user.orgaddr,
          senderName: this.$store.state.user.orgname + viewSenderNameOrg,
          senderBrokerAddress: this.$store.state.user.useraddr,
          senderBrokerName: this.$store.state.user.username + viewSenderBrokerName,
          senderOrganizationRegistrationNumber: this.$store.state.user.orgreg,
          receiverAddress: '',
          receiverName: '',
          receiverBrokerAddress: '',
          receiverBrokerName: '',
          receiverOrganizationRegistrationNumber: '',
          receiverEmail: '',
          receiverPhone: '',
          receiverKey: '',
          receiverOrgNum: ''
        }
        this.ctrTblList.push(ctrTblListBaseData)
      }
    },
		ctrLockTypeSelect (data) {
			if(this.ctrGlobalFrm.ctrLockType !== '') {
				this.$refs.confirm.open('confirm', '열람인증', "열람인증 방식을 변경하면 저장된 데이타는 삭제됩니다.").then(() => {
					this.ctrGlobalFrm.ctrLockType = data
					this.setCtrList(1)
				})
			}else {
				this.ctrGlobalFrm.ctrLockType = data
				this.setCtrList(1)
			}

      switch (data) {
        case 'OFFICE':
          this.ctrGlobalFrm.ctrLockType = this.KeyNames.ctrLockType.Office
          this.ctrLockTypeForFrm = this.KeyNames.ctrLockType.Office
					this.ctrFormBaseType = 'ORG'
					this.companyForm = true
					this.personForm = false
					this.ctrSignRadio1 = true
					this.ctrSignRadio2 = true
          break
        case 'PHONE':
          this.ctrGlobalFrm.ctrLockType = this.KeyNames.ctrLockType.Phone
          this.ctrLockTypeForFrm = this.KeyNames.ctrLockType.Phone
					this.ctrFormBaseType = 'PHONE'
					this.companyForm = false
					this.personForm = true
					this.ctrSignRadio1 = false
					this.ctrSignRadio2 = true
          break
        case 'KEY':
          this.ctrGlobalFrm.ctrLockType = this.KeyNames.ctrLockType.Key
          this.ctrLockTypeForFrm = this.KeyNames.ctrLockType.Key
					this.ctrFormBaseType = 'KEY'
					this.companyForm = false
					this.personForm = true
					this.ctrSignRadio1 = false
					this.ctrSignRadio2 = true
          break
        case 'EMAIL':
          this.ctrGlobalFrm.ctrLockType = this.KeyNames.ctrLockType.Email
          this.ctrLockTypeForFrm = this.KeyNames.ctrLockType.Email
					this.ctrFormBaseType = 'EMAIL'
					this.companyForm = false
					this.personForm = true
					this.ctrSignRadio1 = false
					this.ctrSignRadio2 = true
          break
			}
		},
		addReciverData() {
			let index = 0
			if(this.ctrGlobalFrm.ctrLockType === 'OFFICE') {
				index = this.ctrFrmBaseData.ctrFrm.length + 1
				this.setCtrList(index)
			}else {
				index = this.ctrFrmBaseData.ctrFrm1.length + 1
				this.setCtrList(index)
			}
		},
		contractSignSelect (signFlag) {
			if(this.saveYn) {
				this.ctrWriteBtn = false
			}
      switch (signFlag) {
        case 'AUTH' :
          this.ctrGlobalFrm.ctrSignType = 1
          break
        case 'SIMPLE' :
          this.ctrGlobalFrm.ctrSignType = 0
          break
      }
		},
		makeReqParamByStep (frmNm) {
      if (this.ctrGlobalFrm.receiverOrgNum === this.$store.state.user.orgreg) {
        this.$refs.confirm.open('alert', '수신자 설정오류', '자신에게 비회원 계약을 발송할 수 없습니다\n(사업자 번호를 확인하여 주세요)')
      } else {
				// 신규 계약 작성 step별로 파라미터를 생성한다.
        if (this.step === 1) {
          // 전역 파라미터 생성
          this.makeGlobalReqParam(this.KeyNames.frmName.ctrGlobalFrm)

					let isValidCtrData = false
					isValidCtrData = this.hasValidKeyValInCtrStep1Data()
          // isValidCtrData = true
          if (isValidCtrData) {
						this.reqParamJson[this.KeyNames.ctrTblListName] = this.ctrTblList // ctrOrder가 재지정된 테이블 리스트 재할당
						this.reqParamJson[this.KeyNames.frmName.ctrFrmBaseData] = this.ctrFrmBaseData.ctrFrm
            this.reqParamJson[frmNm] = makeNewCtrParamsByStep(this.ctrFrmStep1, this.step)
            this.$store.dispatch('setTargetJson', this.reqParamJson)
            // 최종 데이터 확인용
            this.$emit('nextStep', this.step, this.reqParamJson)
          } else {
						this.$refs.confirm.open('alert', '수신자 설정오류', '수신자 입력 후 저장 버튼을 눌러주세요.')
          }
        } else {
          this.$refs.confirm.open('alert', '수신자 설정오류', '수신자 입력 후 저장 버튼을 눌러주세요.')
        }
      }
		},
		makeGlobalReqParam (frmNm) {
      // 테이블 리스트의 ctrOrder를 다시 지정해준다.
      this.setFinalCtrTblOrder()
      // ctrTable의 첫번째 행 데이터를 Master 데이터로 셋팅하기 위함
			let firstRowData = []
			firstRowData = this.ctrTblList[0]

      // 전역적으로 사용되는 form이나 요소 파라미터를 생성한다.
      this.reqParamJson[frmNm] = makeGlobalReqParam(this.ctrGlobalFrm)

      // 계약대상 작성 테이블 파라미터 생성
      this.reqParamJson[this.KeyNames.ctrTblListName] = this.ctrTblList

      // ctrTable의 첫번째 행 데이터로 Master 데이터를 overwrite
      this.reqParamJson[frmNm].receiverAddress = ''
      this.reqParamJson[frmNm].receiverAddress = firstRowData.receiverAddress

      this.reqParamJson[frmNm].receiverName = ''
      this.reqParamJson[frmNm].receiverName = firstRowData.receiverName

      this.reqParamJson[frmNm].receiverBrokerAddress = ''
      this.reqParamJson[frmNm].receiverBrokerAddress = firstRowData.receiverBrokerAddress

      this.reqParamJson[frmNm].receiverBrokerName = ''
      this.reqParamJson[frmNm].receiverBrokerName = firstRowData.receiverBrokerName

      // this.reqParamJson[frmNm].ctrLockType = this.finalLockType(this.ctrLockTypeForFrm)
      this.reqParamJson[frmNm].ctrLockType = this.finalLockType(this.ctrLockTypeForFrm) != undefined ? this.finalLockType(this.ctrLockTypeForFrm) : this.ctrRadio === "PHONE" ? 2 : this.ctrGlobalFrm.ctrSignType
		},
		finalLockType (ctrLockTypeData) {
      switch (ctrLockTypeData) {
        case 'OFFICE':
          return 1
        case 'PHONE':
          return 2
        case 'KEY':
          return 3
        case 'EMAIL':
          return 0
      }
    },
		hasValidKeyValInCtrStep1Data () {
      // ctrGlobalFrm, ctrTblList 키가 존재하면 우선 파라미터 키는
      // 생성된것으로 판단한다
      let isValidData = false
      let isValidCtrGlobalFrm = false // master데이터 맞는지 검사
      let isValidCtrTblList = false // detail(테이블) 데이터 맞는지 검사
			let whiteSpcTestPattern = ''
			whiteSpcTestPattern = /^\s+$/
			let keyValue = ''
      // 수신자 설정 테이블의 파라미터 키가 설정되있는지 검사한다
      if (Object.keys(this.reqParamJson).length > 0) {
        for (keyValue in this.reqParamJson) {
          if (keyValue.indexOf(this.KeyNames.frmName.ctrGlobalFrm) > -1) {
            isValidCtrGlobalFrm = true
          }
          if (keyValue.indexOf(this.KeyNames.ctrTblListName) > -1) {
            isValidCtrTblList = true
          }
        }
        // 수신자 정보(Master) 검사 계약 종류에 따라 검사 방식을 조절해야 함
        if (
          this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm] !== undefined &&
          this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm] != null &&
          Object.keys(this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm]).length > 0
        ) {
          let errCtrMasterInfoCnt = 0
					let ownerAddress = ''
          let ownerName = ''
          let senderAddress = ''
          let senderName = ''
          let senderBrokerAddress = ''
          let receiverEmail = ''

          ownerAddress = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].ownerAddress
          ownerName = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].ownerName
          senderAddress = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].senderAddress
          senderName = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].senderName
          senderBrokerAddress = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].senderBrokerAddress
          receiverEmail = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].receiverEmail
          // let receiverAddress = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].receiverAddress
          // let receiverBrokerAddress = this.reqParamJson[this.KeyNames.frmName.ctrGlobalFrm].receiverBrokerAddress

          if (
            (ownerAddress === undefined || ownerAddress == null || ownerAddress === '' || whiteSpcTestPattern.test(ownerAddress)) &&
            (ownerName === undefined || ownerName == null || ownerName === '' || whiteSpcTestPattern.test(ownerName))
          ) {
            // 수신자 설정 레이어에서 owner,sender 정보들을 셋팅하므로 비어있으면 오류
            errCtrMasterInfoCnt++
          }

          if (
            (senderAddress === undefined || senderAddress == null || senderAddress === '' || whiteSpcTestPattern.test(senderAddress)) &&
            (senderName === undefined || senderName == null || senderName === '' || whiteSpcTestPattern.test(senderName))
          ) {
            // 수신자 설정 레이어에서 owner,sender 정보들을 셋팅하므로 비어있으면 오류
            errCtrMasterInfoCnt++
          }

          if (
            (senderAddress === undefined || senderAddress == null || senderAddress === '' || whiteSpcTestPattern.test(senderAddress)) &&
            (senderBrokerAddress === undefined || senderBrokerAddress == null || senderBrokerAddress === '' || whiteSpcTestPattern.test(senderBrokerAddress))
          ) {
            // 수신자 설정 레이어에서 계약요청, 대행자 체인주소 등의 정보를 셋팅하므로
            // 둘다 없으면 오류
            errCtrMasterInfoCnt++
          }
          if (
            receiverEmail === undefined || receiverEmail === null || receiverEmail === ''
          ) {
            // 수신자의 주소나 이름은 없을지라도 이메일은 반드시 있으므로 비어있으면 오류
            errCtrMasterInfoCnt++
          }

          if (errCtrMasterInfoCnt > 0) {
            isValidCtrGlobalFrm = false
          }
        }
        if (this.reqParamJson[this.KeyNames.ctrTblListBaseData] !== undefined &&
            this.reqParamJson[this.KeyNames.ctrTblListName] !== null &&
            this.reqParamJson[this.KeyNames.ctrTblListName].length > 0
        ) {
          let errReceiverInfoCnt = 0
          for (let i = 0; i < this.reqParamJson[this.KeyNames.ctrTblListName].length; i++) {
						let receiverEmail =''
            receiverEmail = this.reqParamJson[this.KeyNames.ctrTblListName][i].receiverEmail
            if (receiverEmail === undefined || receiverEmail === null || receiverEmail === '') {
              errReceiverInfoCnt++
            }
          }
          if (errReceiverInfoCnt > 0) {
            isValidCtrTblList = false
          }
        }
      }
      if (isValidCtrGlobalFrm && isValidCtrTblList) {
        isValidData = true
      } else {
        isValidData = false
      }

      return isValidData
		},
		setFinalCtrTblOrder () {
      // 테이블 데이터의 ctrOrder를 최종적으로 다시 지정해 준다
      for (var i = 0; i < this.ctrTblList.length; i++) {
        var order = i + 1
        this.ctrTblList[i].ctrOrder = order
      }
		},
		delCtrTblRow (index, rows) {
      rows.splice(index, 1)
		},
		requestDisplay() {
			this.step1Cntrl.disBrkSelBtn = "Y"

			if(this.ctrGlobalFrm.ctrLockType === 1) {
				this.companyForm = true
				this.personForm = false
				this.ctrRadio = "OFFICE"
			}else if(this.ctrGlobalFrm.ctrLockType === 2) {
				this.companyForm = true
				this.personForm = false
				this.ctrRadio = "PHONE"
			}else if(this.ctrGlobalFrm.ctrLockType === 3) {
				this.companyForm = true
				this.personForm = false
				this.ctrRadio = "KEY"
			}else if(this.ctrGlobalFrm.ctrLockType === 0) {
				this.companyForm = true
				this.personForm = false
				this.ctrRadio = "EMAIL"
			}
			if(this.ctrGlobalFrm.ctrSignType === 1) {
				this.signCert = 1
			}else if(this.ctrGlobalFrm.ctrSignType === 0) {
				this.signCert = 0
			}
			this.ctrWriteBtn = false
		}
  }
}

</script>
